import React from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'
import { useToasts } from 'react-toast-notifications'

import { WarningModal } from '../../ui'

export const DeleteUserModal = ({
  id,
  name,
  isVisible,
  setModalVisibility,
  userDelete,
}) => {
  const { addToast } = useToasts()
  const [backEndErrors, setBackEndErrors] = React.useState({})

  const DeleteUser = async id => {
    axios({
      method: 'post',
      url: `v1/delete-user/${id}`,
    })
      .then(response => {
        if (response.data.success) {
          userDelete()
          setModalVisibility(false)
          addToast('User deleted successfully', { appearance: 'success' })
        } else {
          addToast('Error deleting user, please try again', {
            appearance: 'error',
          })
        }
      })
      .catch(error => {
        console.log(error)
        if (error.response.status === 422) {
          setBackEndErrors(error.response.data.errors)
        } else {
          setBackEndErrors(error.response.data.error)
          addToast(`Error deleting user, please try again`, {
            appearance: 'error',
          })
        }
      })
  }

  return (
    <WarningModal
      isVisible={isVisible}
      heading="Delete User?"
      closeFunc={() => setModalVisibility(false)}
      submitButtonText="Delete User"
      submitFunc={() => DeleteUser(id)}
      backEndErrors={backEndErrors}
    >
      <b>{name}</b> will no longer be able to access Pinpoint CRM
    </WarningModal>
  )
}

DeleteUserModal.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  isVisible: PropTypes.bool.isRequired,
  setModalVisibility: PropTypes.func.isRequired,
  userDelete: PropTypes.func.isRequired,
}
